import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { Features } from './pages/Features';
import { Pricing } from './pages/Pricing';
import { About } from './pages/About';
import { Resources } from './pages/Resources';
import { Contact } from './pages/Contact';
function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/features" element={<Features data-id="element-6" />} data-id="element-5" />
          <Route path="/pricing" element={<Pricing data-id="element-8" />} data-id="element-7" />
          <Route path="/about" element={<About data-id="element-10" />} data-id="element-9" />
          <Route path="/resources" element={<Resources data-id="element-12" />} data-id="element-11" />
          <Route path="/contact" element={<Contact data-id="element-14" />} data-id="element-13" />
        </Routes>
      </Layout>
    </Router>;
}
export { App };